<template>
  <div class="lesson-content">
    <h1>Advanced Monitoring Features</h1>
    <p>This lesson covers advanced monitoring features in CodeWatchShip that help you track your repositories more effectively.</p>

    <h2>Custom Monitoring Rules</h2>
    <p>You can define custom monitoring rules using the following syntax:</p>
    <pre><code>{
  "rules": [
    {
      "type": "fileChange",
      "pattern": "src/**/*.js",
      "notify": ["slack", "email"]
    },
    {
      "type": "commitMessage",
      "pattern": "^fix:",
      "priority": "high"
    }
  ]
}</code></pre>

    <h2>Available Rule Types</h2>
    <ul>
      <li><strong>fileChange</strong>: Monitor specific file patterns</li>
      <li><strong>commitMessage</strong>: Watch for specific commit message patterns</li>
      <li><strong>branchUpdate</strong>: Track branch updates</li>
      <li><strong>pullRequest</strong>: Monitor pull request activity</li>
    </ul>

    <h2>Priority Levels</h2>
    <p>Configure notification priority levels:</p>
    <ul>
      <li><strong>low</strong>: Basic notifications</li>
      <li><strong>medium</strong>: Important changes</li>
      <li><strong>high</strong>: Critical updates</li>
      <li><strong>urgent</strong>: Immediate attention required</li>
    </ul>

    <h2>Custom Notification Templates</h2>
    <p>Create custom notification templates in <code>templates/</code>:</p>
    <pre><code>// templates/slack-notification.js
module.exports = {
  title: '${repository} - ${event}',
  body: 'Changes detected in ${files}',
  footer: 'Priority: ${priority}'
}</code></pre>

    <h2>Summary</h2>
    <p>You've learned about advanced monitoring features in CodeWatchShip. Next, we'll explore integration with CI/CD pipelines.</p>
  </div>
</template>

<script>
export default {
  name: 'Chapter2Lesson1'
}
</script>

<style scoped>
.lesson-content {
  color: var(--text);
  line-height: 1.6;
}

h1 {
  color: var(--primary);
  font-size: 2rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
}

h2 {
  color: var(--text);
  font-size: 1.5rem;
  margin: 2rem 0 1rem;
  font-weight: 600;
}

p {
  margin-bottom: 1rem;
}

ul, ol {
  margin-bottom: 1rem;
  padding-left: 1.5rem;
}

li {
  margin-bottom: 0.5rem;
}

pre {
  background: #f8fafc;
  border-radius: 6px;
  padding: 1rem;
  margin: 1rem 0;
  overflow-x: auto;
  border: 1px solid var(--border);
}

code {
  font-family: 'Fira Code', 'Consolas', monospace;
  font-size: 0.9rem;
}

p code {
  background: #f8fafc;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-size: 0.9rem;
}

strong {
  font-weight: 600;
}
</style> 